import { render, staticRenderFns } from "./activity-upload-video-detail.vue?vue&type=template&id=28e47949&scoped=true&"
import script from "./activity-upload-video-detail.vue?vue&type=script&lang=js&"
export * from "./activity-upload-video-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-upload-video-detail.vue?vue&type=style&index=0&id=28e47949&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e47949",
  null
  
)

export default component.exports